export default "__VITE_ASSET__W9R6znzb__"